/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seating_Severity_BlockingInputs */



/**
* | output |
* | --- |
* | "Blocking issue" |
*
* @param {Seating_Severity_BlockingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const seating_severity_blocking = /** @type {((inputs?: Seating_Severity_BlockingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seating_Severity_BlockingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Problème bloquant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema bloqueante")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Problema bloqueante")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema bloccante")
	return /** @type {LocalizedString} */ ("Blocking issue")
});